import dynamic from 'next/dynamic';
import ComposerUiMfeGate from '@/common/ComposerUi/ComposerUiMfeGate';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import Modals from '@/home/Modals';
import HideOnNative from '~/components/common/HideOnNative';
import { isTest } from '~/constants/environment';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import NativeError from '~/native/NativeError';

const FeatureBranch = dynamic(
  () =>
    import(/* webpackChunkName: "FeatureBranch" */ '@/common/FeatureBranch'),
  { ssr: false }
);

const NewUser = dynamic(
  () => import(/* webpackChunkName: "NewUser" */ './NewUser')
);

const ReturnUser = dynamic(
  () => import(/* webpackChunkName: "ReturnUser" */ './ReturnUser')
);

export default function HomeContainer() {
  const isReturningUser = useGetIsReturnUser();

  return (
    <>
      <HideOnNative>
        <PageHeader />
      </HideOnNative>
      <NativeError />
      {isTest && <FeatureBranch />}
      {isReturningUser ? <ReturnUser /> : <NewUser />}
      <HideOnNative>
        <PageFooter className="bg-background-default" />
      </HideOnNative>
      <Modals />
      <ComposerUiMfeGate />
    </>
  );
}
